// Generated by CoffeeScript 2.7.0
var EditTagGroupModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import FieldList from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

export default EditTagGroupModal = Vue.extend({
  components: {
    'modal': Modal,
    'field-list': FieldList
  },
  props: {
    title: {
      type: String
    },
    initialTagGroupName: {
      type: String,
      default: ''
    },
    callback: {
      type: Function
    }
  },
  data: function() {
    return {
      tagGroupName: this.initialTagGroupName,
      valid: true
    };
  },
  template: `<modal :title="title"
       extendClass="tag-group-modal"
       @ensureClicked="ensureClicked"
       size='small'
       ref="tagGroupModalRef">
  <template>
    <div class="modal-body mt-5" >
      <div class="form-field required" :class="{ 'has-error': !valid }">
        <div class="form-field-head">
          <div class="form-field-title">标签分组名称</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input class="form-field-value" placeholder="请输入标签分组名称" type="text" v-model.trim="tagGroupName">
          </div>
          <div class="message">不能为空</div>
        </div>
      </div>
    </div>
  </template>
</modal>`,
  methods: {
    ensureClicked: function() {
      this._validate();
      if (!this.valid) {
        this.$refs.tagGroupModalRef.open();
        return;
      }
      return this.callback(this.tagGroupName);
    },
    _validate: function() {
      return this.valid = this.tagGroupName;
    }
  }
});
